import { InputFieldProps } from "../../interface";
import * as React from "react";

class InputField extends React.Component<React.InputHTMLAttributes<HTMLInputElement> & InputFieldProps> {
    public onChangeField = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const target = e.target;
        if (this.props.name && this.props.onChangeField) this.props.onChangeField(target.value, this.props.name);
    };
    public render(): React.ReactElement {
        // declare onChange to avoid it replace onChange property in <input> element
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { title, value, type, error, onChangeField, ...other } = this.props;
        return (
            <div className="inputfield-holder">
                {title}
                <input type={type} value={value} onChange={this.onChangeField} {...other} />
                <div className="error" id={`${other.id || ""}-error`}>
                    {error || ""}
                </div>
            </div>
        );
    }
}
export { InputField };
